import PhotoSizeDimensions from '@alltrails/types/PhotoSizeDimensions';
import getPhotoSizeServerFromDimensions from './getPhotoSizeServerFromDimensions';
import { X_AT_KEY } from './api';

type Args = {
  id: string | number;
  size: PhotoSizeDimensions | { width: number; height: number };
};

const getPhotoUrlFromId = ({ id, size }: Args) => {
  const params = new URLSearchParams();
  params.set('key', X_AT_KEY);

  const sizeString = typeof size === 'string' ? getPhotoSizeServerFromDimensions(size) : `${size.width}w${size.height}h`;
  params.set('size', sizeString);

  return `/api/alltrails/photos/${id}/image?${params.toString()}`;
};

export default getPhotoUrlFromId;
